<template>
<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="28" cy="28" r="28" fill="url(#paint0_linear)"/>
<path d="M16 38.2853L40 27.9996L16 17.7139V25.7139L33.1429 27.9996L16 30.2853V38.2853Z" fill="white"/>
<defs>
<linearGradient id="paint0_linear" x1="28" y1="0" x2="28" y2="56" gradientUnits="userSpaceOnUse">
<stop stop-color="#727CF5"/>
<stop offset="0.0001" stop-color="#727CF5"/>
<stop offset="1" stop-color="#4CC0EC"/>
</linearGradient>
</defs>
</svg>


</template>

<script>
export default {

}
</script>

<style scoped>
svg {cursor: pointer !important;}
</style>